"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibleTools = void 0;
const constants = __importStar(require("../constants/SidebarBSSPlatformToolsConstants"));
const visibleTools = (products, enabledTools, userRole, currentTool) => {
    const filteredProducts = products.filter((product) => {
        const tool = matchingTool(product, enabledTools);
        // if the link doesn't exist, return false
        if (tool && (!tool.url || tool.url === ""))
            return false;
        // if the user doesn't have the grant to access the tool, return false
        if (product.roles.filter((role) => role === userRole).length === 0)
            return false;
        // if the selected tool is configured with enabled=true or undefined, return true
        if (tool && tool.enabled !== false)
            return true;
        // if the tool is not configured return false
        return false;
    });
    const toolsWithUrl = filteredProducts.map((product) => {
        const tool = matchingTool(product, enabledTools);
        return { name: product.name, url: tool && tool.url ? tool.url : "" };
    });
    // put currentTool to the top of the list
    const currentToolIndex = toolsWithUrl.findIndex((tool) => tool.name === currentTool);
    if (currentToolIndex !== -1) {
        const firstTool = toolsWithUrl[currentToolIndex];
        toolsWithUrl.splice(currentToolIndex, 1);
        toolsWithUrl.unshift(firstTool);
    }
    return toolsWithUrl;
};
exports.visibleTools = visibleTools;
const matchingTool = (product, enabledTools) => {
    // in some configurations, the EMOTIONS tool is called NEUROSALES
    return enabledTools.find((tool) => tool.name === product.name ||
        (tool.name === constants.NEUROSALES && product.name === constants.EMOTIONS));
};
